var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { injectIntl } from 'react-intl';
import range from 'lodash/range';
import identity from 'lodash/identity';
import Select from '../../../../components/Deposit/Select';
import Input from '../../../../components/Deposit/TextInput';
import * as Parser from '../../Payment/PaymentAccountParser';
import CardInput from '../../../../components/Deposit/CardInput';
import translate from '../../../../lib/utils/translate';

var monthRange = range(1, 13).map(function (month) {
  var m = month < 10 ? '0' + month : month;
  return { value: m, label: m };
});

var currentYear = new Date().getFullYear(); // current year in 2-digit format, i.e. 2018 --> 18

var yearRange = range(currentYear, currentYear + 10).map(function (year) {
  return {
    value: year,
    label: year.toString().substr(2)
  };
});

var injectMethod = function injectMethod(method, BaseComponent) {
  return function (props) {
    return React.createElement(BaseComponent, _extends({}, props, { method: method }));
  };
};

var Creditcard = function Creditcard(_ref) {
  var account = _ref.account,
      intl = _ref.intl,
      method = _ref.method;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(
      'div',
      { className: 'layout-item' },
      React.createElement(CardInput, {
        className: method === 'withdraw' ? 'layout-item-12' : 'layout-item-9',
        disabled: account.accountId,
        name: 'cardNumber',
        label: translate({ id: 'cashier.details.cardNumber' }, intl),
        required: !account.accountId,
        type: 'number',
        autocomplete: 'cc-number'
      }),
      method === 'deposit' && React.createElement(CardInput, {
        className: 'layout-item-3',
        name: 'cvv',
        label: translate({ id: 'cashier.details.cvv' }, intl),
        required: true,
        type: 'cvv',
        autocomplete: 'cc-csc'
      })
    ),
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'cardHolder',
      title: translate({ id: 'cashier.details.cardHolder' }, intl),
      required: !account.accountId,
      autocomplete: 'cc-name'
    }),
    React.createElement(
      'div',
      { className: 'layout-item' },
      React.createElement(Select, {
        className: 'layout-item-6',
        disabled: account.accountId,
        name: 'expiryMonth',
        title: translate({ id: 'cashier.details.expiryMonth' }, intl),
        options: monthRange,
        required: !account.accountId
      }),
      React.createElement(Select, {
        className: 'layout-item-6',
        disabled: account.accountId,
        name: 'expiryYear',
        title: translate({ id: 'cashier.details.expiryYear' }, intl),
        options: yearRange,
        required: !account.accountId
      })
    )
  );
};

var Neteller = function Neteller(_ref2) {
  var account = _ref2.account,
      intl = _ref2.intl,
      method = _ref2.method;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'account',
      title: translate({ id: 'cashier.details.account' }, intl)
    }),
    method === 'deposit' && React.createElement(Input, {
      name: 'secureId',
      label: translate({ id: 'cashier.details.secureId' }, intl)
    })
  );
};

var VenusPoint = function VenusPoint(_ref3) {
  var account = _ref3.account,
      intl = _ref3.intl;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'username',
      value: account.maskedAccount,
      label: translate({ id: 'cashier.details.username' }, intl)
    }),
    React.createElement(Input, {
      type: 'password',
      name: 'password',
      label: translate({ id: 'cashier.details.password' }, intl)
    })
  );
};

var Vega = function Vega(_ref4) {
  var account = _ref4.account,
      intl = _ref4.intl;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'username',
      value: account.maskedAccount,
      label: translate({ id: 'cashier.details.username' }, intl)
    }),
    React.createElement(Input, {
      type: 'password',
      name: 'password',
      label: translate({ id: 'cashier.details.password' }, intl)
    })
  );
};

var PPro = function PPro() {
  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, { type: 'hidden', name: 'service', value: 'GIROPAY' })
  );
};

var PhoneNumber = function PhoneNumber(_ref5) {
  var account = _ref5.account,
      intl = _ref5.intl;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'phoneNumber',
      title: translate({ id: 'cashier.details.phoneNumber' }, intl)
    })
  );
};

var Email = function Email(_ref6) {
  var account = _ref6.account,
      intl = _ref6.intl;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      disabled: account.accountId,
      value: account.accountId ? account.maskedAccount : undefined,
      name: 'email',
      label: translate({ id: 'cashier.details.email' }, intl)
    })
  );
};

var Banklocal = function Banklocal(_ref7) {
  var account = _ref7.account,
      intl = _ref7.intl;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      value: account.accountId ? account.maskedAccount.replace(/-\d*/g, '') : undefined,
      name: 'clearingNumber',
      title: translate({ id: 'cashier.details.clearingNumber' }, intl),
      disabled: account.accountId
    }),
    React.createElement(Input, {
      value: account.accountId ? account.maskedAccount.replace(/\d*-/g, '') : undefined,
      name: 'accountNumber',
      title: translate({ id: 'cashier.details.iban' }, intl),
      disabled: account.accountId
    })
  );
};

export var SkrillDeposit = {
  component: injectIntl(Email),
  parser: identity
};

export var CreditcardDeposit = {
  component: injectMethod('deposit', injectIntl(Creditcard)),
  parser: Parser.parseCreditcard
};

export var NetellerDeposit = {
  component: injectMethod('deposit', injectIntl(Neteller)),
  parser: Parser.parseNeteller
};

export var VenusPointDeposit = {
  component: injectMethod('deposit', injectIntl(VenusPoint)),
  parser: Parser.parseVenusPoint
};

export var VegaDeposit = {
  component: injectMethod('deposit', injectIntl(Vega)),
  parser: Parser.parseVega
};

export var SiruDeposit = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var MuchBetterDeposit = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var PProDeposit = {
  component: injectIntl(PPro),
  parser: identity
};

export var MobilePayDeposit = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var SwishDeposit = null;
export var ZimplerDeposit = null;
export var BankDeposit = null;
export var TrustlyDeposit = null;
export var EcoPayzDeposit = null;
export var EProPaymentWallDeposit = null;
export var IdealDeposit = null;
export var IDebitDeposit = null;
export var InstadebitDeposit = null;
export var PaysafecardDeposit = null;

export var BankLocalWithdrawal = {
  component: injectIntl(Banklocal),
  parser: identity
};

export var SkrillWithdrawal = {
  component: injectIntl(Email),
  parser: identity
};

export var CreditcardWithdrawal = {
  component: injectMethod('withdraw', injectIntl(Creditcard)),
  parser: Parser.parseCreditcard
};

export var VenusPointWithdrawal = {
  component: injectMethod('withdraw', injectIntl(VenusPoint)),
  parser: Parser.parseVenusPoint
};

export var VegaWithdrawal = {
  component: injectMethod('withdraw', injectIntl(Vega)),
  parser: Parser.parseVega
};

export var NetellerWithdrawal = {
  component: injectMethod('withdraw', injectIntl(Neteller)),
  parser: Parser.parseNeteller
};

export var MuchBetterWithdrawal = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var ZimplerWithdrawal = null;
export var BankWithdrawal = null;
export var TrustlyWithdrawal = null;
export var EcoPayzWithdrawal = null;
export var EProPaymentWallWithdrawal = null;
export var IdealWithdrawal = null;
export var IDebitWithdrawal = null;
export var InstadebitWithdrawal = null;
export var PaysafecardWithdrawal = null;
export var InteracWithdrawal = null;